import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api.js';
import { STALE } from '@/lib/query-cache.js';

interface IssueType {
  id: string;
  name: string;
}

interface Priority {
  id: string;
  name: string;
}

interface AssignableUser {
  accountId: string;
  displayName: string;
  avatarUrl: string | null;
  /** jira: Jira account. portal: assigned through the portal ("portal:<email>" id), notified on Slack. */
  kind?: 'jira' | 'portal';
}

export function useAllStatuses() {
  return useQuery({
    queryKey: ['meta', 'statuses'],
    queryFn: () => api.get<string[]>('/api/meta/statuses').then((r) => r.data),
    staleTime: STALE.METADATA,
  });
}

export function useProjectStatuses(projectKey: string) {
  return useQuery({
    queryKey: ['meta', 'statuses', projectKey],
    queryFn: () => api.get<string[]>(`/api/meta/projects/${projectKey}/statuses`).then((r) => r.data),
    enabled: !!projectKey,
    staleTime: STALE.METADATA,
  });
}

export function usePriorities() {
  return useQuery({
    queryKey: ['meta', 'priorities'],
    queryFn: () => api.get<Priority[]>('/api/meta/priorities').then((r) => r.data),
    staleTime: STALE.METADATA,
  });
}

export function useProjectIssueTypes(projectKey: string) {
  return useQuery({
    queryKey: ['meta', 'types', projectKey],
    queryFn: () => api.get<IssueType[]>(`/api/meta/projects/${projectKey}/types`).then((r) => r.data),
    enabled: !!projectKey,
    staleTime: STALE.METADATA,
  });
}

export function useAssignableUsers(projectKey: string) {
  return useQuery({
    queryKey: ['meta', 'users', projectKey],
    queryFn: () => api.get<AssignableUser[]>(`/api/meta/projects/${projectKey}/users`).then((r) => r.data),
    enabled: !!projectKey,
    staleTime: STALE.METADATA,
  });
}
